import i18next from 'i18next';
import { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { initI18n } from './i18n';

export type Language = 'sv' | 'en';

void initI18n();

interface TranslationProviderProps {
  children: ReactNode;
}
export const TranslationProvider = ({ children }: TranslationProviderProps) => {
  return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>;
};
